import {useAuthStore} from '@core/stores/authStore';
import WebSocketService from "@core/services/websocket/webSocketService";

export default function authHeader(type = 'application/json') {
  const store = useAuthStore()


  const currentWsId = WebSocketService.getInstance().getCurrentWsId()

  if (store.currentUser && store.currentUser.access_token) {
    let bearer = 'Bearer ' + store.currentUser.access_token
    return {
      'ws-id': currentWsId,
      //'x-access-token': store.currentUser.accessToken,
      'Authorization': bearer,
      'x-auth-token': bearer,
      'Content-Type': type
    }
  } else if (currentWsId) {
    return  {'Content-Type': type,'ws-id': currentWsId}
  } else {
    return  {'Content-Type': type}
  }
}
